import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  DialogContentText,
  Checkbox,
  FormGroup,
  FormControlLabel
} from '@mui/material';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { getGroupTree, getAlarmConfig, postGroupTree, user,deleteGroupTree } from "../../Restclient/datacollection";
import { updateSelectedNodes } from "../../store/alarm_data.js";
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CustomDialogBox from "../CommonComponents/CustomDialogBox.jsx";
import CustomCancelButton from '../CommonComponents/CustomCancelButton.jsx';
import CustomButton from '../CommonComponents/CustomButton.jsx';

// Initial groups with their tree structures
const initialGroups = {
  'Group 1': [
    {
      id: '1',
      label: 'Root Node',
      alertrules: [],
      notificationrules: [],
      reportrules: [],
      expanded: false,
      children: []
    }
  ],
  'Group 2': [
    {
      id: '2',
      label: 'Root Node',
      alertrules: [],
      notificationrules: [],
      reportrules: [],
      expanded: false,
      children: []
    }
  ]
};


const alarmRules = ['Rule 1', 'Rule 2', 'Rule 3'];
const reportRules = ['Rule 4', 'Rule 5', 'Rule 6'];
const notificationRules = ['Rule 7', 'Rule 8', 'Rule 9'];


const TreeApp = () => {
  const [groups, setGroups] = useState({}); // Store groups with their tree structures
  const [selectedGroup, setSelectedGroup] = useState(''); // Selected group
  const [treeData, setTreeData] = useState([]); // Tree structure of the selected group
  const [openAddNodeDialog, setOpenAddNodeDialog] = useState(false); // Dialog for adding nodes
  const [openAddRuleDialog, setOpenAddRuleDialog] = useState(false); // Dialog for adding rules
  const [selectedNode, setSelectedNode] = useState(null); // Selected node to modify
  const [newNodeName, setNewNodeName] = useState(''); // Name for the new subnode
  const [selectedRules, setSelectedRules] = useState([]); // Selected rules to apply
  const [selectedReportRules, setSelectedReportRules] = useState([]);
  const [selectedNotificationRules, setSelectedNotificationRules] = useState([]);
  const [value, setValue] = React.useState("Alerts");
  const [alarmRules, setAlarmRules] = useState(['Rule 1', 'Rule 2', 'Rule 3']);
  const [reportRules, setReportRules] = useState(['Rule 4', 'Rule 5', 'Rule 6']);
  const [notificationRules, setNotificationRules] = useState(['Rule 7', 'Rule 8', 'Rule 9']);
  const selectedprojectname = useSelector((state) => state.mainpagedata.selectedprojectname);
  const userdetails = useSelector((state) => state.logindata.userdetails)
  const [errMessage, setErrMessage] = useState('');
  const [errExists, setErrExists] = useState(false);
  const [selectedNodes, setSelectedNodes] = useState([]); // Track selected nodes
  const [errExistsOpenDialog, setErrExistsOpenDialog] = useState(false);
  const [openSaveGrp, setOpenSaveGrp] = useState(false);
  const [openAddGroupDialog, setOpenAddGroupDialog] = useState(false);
  const [newGroupName, setNewGroupName] = useState('');
  const themechange = useSelector((state) => state.themedata.theme)
  const tagdetails = useSelector((state) => state.mainpagedata.tagdetailsobject)
  const devicedetails = useSelector((state) => state.mainpagedata.devicedetailsobject)
  const [pagesize, setPagesize] = useState(445)
  const overviewstate = useSelector((state) => state.mainpagedata.overviewbarstate)
  const [openAlarmUpdatedandSaved, setopenAlarmUpdatedandSaved] = useState(false);
  const dispatch = useDispatch();

  const handleOpenSaveGrp = () => {
    setOpenSaveGrp(true);
  }

  const handleCloseSaveGrp = () => {
    setOpenSaveGrp(false);
  }

  const handleOpenAddGroupDialog = () => {
    setNewGroupName('');
    setOpenAddGroupDialog(true);
  }

  const handleCloseAddGroupDialog = () => {
    setOpenAddGroupDialog(false);
    setNewGroupName('');
  }

   function handleConfirmationAlarmUpdatedandSaved(){
      setopenAlarmUpdatedandSaved(false)   
  }

  function handleCloseAlarmUpdatedandSaved(){
      setopenAlarmUpdatedandSaved(false);
  }
  
  const handleConfirmAddGroup = () => {
    if (newGroupName && newGroupName.trim() !== '') {
      handleAddGroup(newGroupName.trim());
    }
    setOpenAddGroupDialog(false);
    setNewGroupName('');
  }

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    dispatch(updateSelectedNodes(selectedNodes)); // Dispatch selected nodes to Redux
}, [selectedNodes, dispatch]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  // Handle group selection
  const handleGroupChange = (event) => {
    const groupName = event.target.value;
    setSelectedGroup(groupName);
    setTreeData(groups[groupName] || []); // Load tree for selected group
  };


  // Handle adding a new group
  const handleAddGroup = (groupName) => {
    if (!groupName) return;


    const newGroup = {
      [groupName]: [
        {
          id: Date.now().toString(), // Unique ID for new root
          label: 'Root Node',
          alertrules: [],
          notificationrules:[],
          reportrules:[],
          expanded: false,
          children: []
        }
      ]
    };


    setGroups({ ...groups, ...newGroup });
    setSelectedGroup(groupName); // Automatically select the new group
    setTreeData(newGroup[groupName]);
  };

  // Handle removing a group
  const handleRemoveGroup = (groupName) => {
    if (!groupName) return;

    // Create a copy of groups without the selected group
    const updatedGroups = { ...groups };
    delete updatedGroups[groupName];

    setGroups(updatedGroups);

    // If the deleted group was selected, clear selection
    if (selectedGroup === groupName) {
      setSelectedGroup('');
      setTreeData([]);
    }
    // // Call backend to delete from database
    // deleteGroupTree(selectedprojectname, userdetails.Userid, deleteGroupTreecallback);
  };

  const getGroupTreecallback = (response) => {
    setGroups(response?.data?.data || initialGroups); // Set groups from response or use initial groups
  }

  const alarmconfigcallback = (res,status) => {
        if(status == 200){
            var currentconfigrules = res?.data?.data;
            if (currentconfigrules && Array.isArray(currentconfigrules)) {
                setAlarmRules(currentconfigrules);
            }else{
                setErrMessage('Could not fetch Alert Rules');
                setErrExists(true);
                setErrExistsOpenDialog(true);
            }
        }else if((status == 500) || (status == 'error')){
            setErrMessage('Could not fetch Alert Rules');
            setErrExists(true)
            setErrExistsOpenDialog(true)
        }
        
    };

  useEffect(() => {
    getGroupTree(selectedprojectname, getGroupTreecallback)
    if(userdetails.Projectid == 'All'){
        getAlarmConfig(selectedprojectname, userdetails.Projectlist, alarmconfigcallback);
    }else{
        getAlarmConfig(userdetails.Projectid, userdetails.Projectlist, alarmconfigcallback);
    } 
  },[selectedprojectname])

  useEffect(() => {
      if (overviewstate) {
          setPagesize(445)
      } else {
          setPagesize(410)
      }
}, [overviewstate])

  const buildNodePath = (tree, stopNode, path = []) => {
    // If the node is null or undefined, return the current path
    if (!tree) return path;
 
    // Add the current node's label to the path
    path.push(tree.label+" > ");
 
    // If we reached the stopNode, return the current path
    if (tree.label === stopNode) {
      return path;
    }
 
    // If the node has children, recursively search through them
    if (tree.children && tree.children.length > 0) {
      for (let child of tree.children) {
        // Recurse into each child and return the path if found
        const resultPath = buildNodePath(child, stopNode, [...path]); // pass a new path array to avoid mutation
        if (resultPath.length > 0) {
          return resultPath; // If a valid path is found, return it
        }
      }
    }
 
    // Return an empty array if no path is found
    return [];
  };
 
 
 
 


  // Handle adding a subnode
  const handleAddSubNode = () => {
    if (!newNodeName) return;

    const newSubNode = {
      id: Date.now().toString(), // Unique ID
      label: newNodeName,
      parentId: selectedNode.id, // Set parentId
      alertrules: selectedRules,
      reportrules: selectedReportRules,
      notificationrules: selectedNotificationRules,
      expanded: false,
      children: []
    };

    // Immutable update: create new children array
    const updateTreeData = (nodes, parentId) => {
      return nodes.map((node) => {
        if (node.id === parentId) {
          return {
            ...node,
            children: [...(node.children || []), newSubNode]
          };
        } else if (node.children) {
          return {
            ...node,
            children: updateTreeData(node.children, parentId)
          };
        }
        return node;
      });
    };

    const newTreeData = updateTreeData(treeData, selectedNode.id);
    setTreeData(newTreeData);
    setGroups(prevGroups => ({
      ...prevGroups,
      [selectedGroup]: newTreeData
    }));
    setSelectedNode(null);
    setNewNodeName('');
    setSelectedRules([]);
    setSelectedReportRules([]);
    setSelectedNotificationRules([]);
    setOpenAddNodeDialog(false);
  };


    // Handle adding a rule
    const handleAddRule = () => {
        // Prevent error if no node is selected
        let shouldUpdateTree = true;
        if (!selectedNode || !selectedNode.id) {
            shouldUpdateTree = false;
        }
        var updateRules;
        if (value == "Alerts") {
            if (selectedRules.length === 0) shouldUpdateTree = false;
            updateRules = (nodes, nodeId) => {
                return nodes.map((node) => {
                    if (node.id === nodeId) {
                        return {
                            ...node,
                            alertrules: [...node.alertrules, ...selectedRules]
                        };
                    } else if (node.children) {
                        return {
                            ...node,
                            children: updateRules(node.children, nodeId)
                        };
                    }
                    return node;
                });
            };
        } else if (value == "Reports") {
            if (selectedReportRules.length === 0) shouldUpdateTree = false;
            updateRules = (nodes, nodeId) => {
                return nodes.map((node) => {
                    if (node.id === nodeId) {
                        return {
                            ...node,
                            reportrules: [...node.reportrules, ...selectedReportRules]
                        };
                    } else if (node.children) {
                        return {
                            ...node,
                            children: updateRules(node.children, nodeId)
                        };
                    }
                    return node;
                });
            };
        } else if (value == "Notifications") {
            if (selectedNotificationRules.length === 0) shouldUpdateTree = false;
            updateRules = (nodes, nodeId) => {
                return nodes.map((node) => {
                    if (node.id === nodeId) {
                        return {
                            ...node,
                            notificationrules: [...node.notificationrules, ...selectedNotificationRules]
                        };
                    } else if (node.children) {
                        return {
                            ...node,
                            children: updateRules(node.children, nodeId)
                        };
                    }
                    return node;
                });
            };
        }
        if (shouldUpdateTree) {
            const newTreeData = updateRules(treeData, selectedNode.id);
            setTreeData(newTreeData);
            // Also update groups[selectedGroup] to keep in sync
            setGroups(prevGroups => ({
                ...prevGroups,
                [selectedGroup]: newTreeData
            }));
        }
        setSelectedRules([]);
        setSelectedReportRules([]);
        setSelectedNotificationRules([]);
        setOpenAddRuleDialog(false);
    };


  // Handle expanding/collapsing nodes
//   const handleExpandClick = (nodeId) => {
//     const updateExpansion = (nodes) => {
//       return nodes.map((node) => {
//         if (node.id === nodeId) {
//           node.expanded = !node.expanded;
//         } else if (node.children) {
//           node.children = updateExpansion(node.children);
//         }
//         return node;
//       });
//     };


//     setTreeData(updateExpansion(treeData));
//   };
// Handle expanding/collapsing nodes
const handleExpandClick = (nodeId) => {
    const updateExpansion = (nodes) => {
      return nodes.map((node) => {
        if (node.id === nodeId) {
          const expanded = !node.expanded;
          let children = node.children;
          if (!expanded) {
            // Collapse all child nodes recursively
            const collapseChildren = (childNodes) => {
              return (childNodes || []).map((child) => ({
                ...child,
                expanded: false,
                children: collapseChildren(child.children || []),
              }));
            };
            children = collapseChildren(node.children || []);
          }
          return {
            ...node,
            expanded,
            children,
          };
        } else if (node.children) {
          return {
            ...node,
            children: updateExpansion(node.children)
          };
        }
        return node;
      });
    };

    setTreeData(updateExpansion(treeData));
  };
 


  // Handle rule selection for the node
  const handleRuleSelection = (rule) => {
    if(value=="Alerts"){
        setSelectedRules((prevRules) => {
            if (prevRules.includes(rule.TagID)) {
              return prevRules.filter((r) => r !== rule.TagID);
            }
            return [...prevRules, rule.TagID];
          });
    }else if(value == "Reports"){
        setSelectedReportRules((prevRules) => {
            if (prevRules.includes(rule)) {
              return prevRules.filter((r) => r !== rule);
            }
            return [...prevRules, rule];
          });
    }else if(value == "Notifications"){
        setSelectedNotificationRules((prevRules) => {
            if (prevRules.includes(rule)) {
              return prevRules.filter((r) => r !== rule);
            }
            return [...prevRules, rule];
          });
    }
   
  };

// Handle removing a subnode
const handleRemoveSubNode = (nodeId, parentId) => {
    const updateTreeData = (nodes) => {
      return nodes
        .filter((node) => node.id !== nodeId) // Remove the node with the given ID
        .map((node) => {
          if (node.id === parentId) {
            node.children = updateTreeData(node.children);
          } else if (node.children) {
            node.children = updateTreeData(node.children);
          }
          return node;
        });
    };
 
    setTreeData(updateTreeData(treeData));
  };
 
  // Handle removing a rule from a node
  const handleRemoveRule = (type_of_Rule,ruleToRemove, nodeId) => {
    var updateRules;
    if(type_of_Rule == "Alerts"){
        updateRules = (nodes) => {
          return nodes.map((node) => {
            if (node.id === nodeId) {
              node.alertrules = node.alertrules.filter((rule) => rule !== ruleToRemove); // Remove the rule
            } else if (node.children) {
              node.children = updateRules(node.children);
            }
            return node;
          });
        };
    }else if(type_of_Rule == "Reports"){
      updateRules = (nodes) => {
        return nodes.map((node) => {
          if (node.id === nodeId) {
            node.reportrules = node.reportrules.filter((rule) => rule !== ruleToRemove); // Remove the rule
          } else if (node.children) {
            node.children = updateRules(node.children);
          }
          return node;
        });
      };
    }else if(type_of_Rule == "Notifications"){
      updateRules = (nodes) => {
        return nodes.map((node) => {
          if (node.id === nodeId) {
            node.notificationrules = node.notificationrules.filter((rule) => rule !== ruleToRemove); // Remove the rule
          } else if (node.children) {
            node.children = updateRules(node.children);
          }
          return node;
        });
      };
    }
    setTreeData(updateRules(treeData));
  };
 
  const handleNodeSelection = (node) => {
    // Only allow one node to be selected at a time
    setSelectedNodes((prevSelected) => {
        const isSelected = prevSelected.length > 0 && prevSelected[0].id === node.id;
        const updatedNodes = isSelected ? [] : [node];
        dispatch(updateSelectedNodes(updatedNodes));
        return updatedNodes;
    });
};

  // Render the tree recursively
  const renderTree = (nodes) => {
   
    return (
      <ul className="tree-app-node-list">
        {nodes.map((node) => {
            const nodePath = buildNodePath(treeData[0], node.label); // Get the path for the current node
            return (
                <li key={node.id} className="tree-app-node-item">
                    <div key={node.id}>
                        <IconButton size="small" onClick={() => handleExpandClick(node.id)}>
                            {node.expanded ? <ExpandLess style={{color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C'}} /> : <ExpandMore style={{color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C'}} />}
                        </IconButton>
                        <Checkbox
                            checked={selectedNodes.some((selectedNode) => selectedNode.id === node.id)}
                            onChange={() => handleNodeSelection(node)}
                            sx={{
                                color: 'var(--HighlightedText_Stroke)',
                                '& .MuiSvgIcon-root': { fontSize: '20px' },
                            }}
                        />
                        {node.label}
                        {node.expanded && (
                            <>
                                {/* Alerts Section */}
                                <div className="tree-app-node-section">
                                    <div><strong>Alert Rules:</strong></div>
                                    {node.alertrules.length > 0 ? (
                                        node.alertrules.map((rule, index) => (
                                            <li key={index}>
                                                {devicedetails[tagdetails[rule]?.DeviceID]?.Name+":"+tagdetails[rule]?.Alias} - Path: {nodePath}
                                                <Button
                                                    size="small"
                                                    color="secondary"
                                                    onClick={() => handleRemoveRule("Alerts", rule, node.id)}
                                                    sx={{textTransform:"none"}}
                                                >
                                                    Remove Rule
                                                </Button>
                                            </li>
                                        ))
                                    ) : (
                                        <div className="tree-app-no-rules">No alert rules</div>
                                    )}
                                </div>
                                {/* Reports Section */}
                                <div className="tree-app-node-section">
                                    <div><strong>Report Rules:</strong></div>
                                    {node.reportrules.length > 0 ? (
                                        node.reportrules.map((rule, index) => (
                                            <li key={index}>
                                                {rule} - Path: {nodePath}
                                                <Button
                                                    size="small"
                                                    color="secondary"
                                                    onClick={() => handleRemoveRule("Reports", rule, node.id)}
                                                    sx={{textTransform:"none"}}
                                                >
                                                    Remove Rule
                                                </Button>
                                            </li>
                                        ))
                                    ) : (
                                        <div className="tree-app-no-rules">No report rules</div>
                                    )}
                                </div>
                                {/* Notification Section */}
                                <div className="tree-app-node-section">
                                    <div><strong>Notification Rules:</strong></div>
                                    {node.notificationrules.length > 0 ? (
                                        node.notificationrules.map((rule, index) => (
                                            <li key={index}>
                                                {rule} - Path: {nodePath}
                                                <Button
                                                    size="small"
                                                    color="secondary"
                                                    onClick={() => handleRemoveRule("Notifications", rule, node.id)}
                                                    sx={{textTransform:"none"}}
                                                >
                                                    Remove Rule
                                                </Button>
                                            </li>
                                        ))
                                    ) : (
                                        <div className="tree-app-no-rules">No notification rules</div>
                                    )}
                                </div>
                                {/* Render children recursively */}
                                {renderTree(node.children)}
                            </>
                        )}
                        {/* Add buttons for subnode and rule actions */}
                        <br />
                        <Button
                        sx={{ textTransform: 'none' }}
                        onClick={() => {
                            setSelectedNode(node);
                            setOpenAddNodeDialog(true);
                        }}
                        >
                        Add Subnode
                        </Button>
                        <br />
                        <Button
                        sx={{ textTransform: 'none' }}
                        onClick={(e) => {
                            setSelectedNode(node);
                            handleChange(e, "Alerts")
                        }}
                        >
                        Add Alert Rule
                        </Button>
                        <Button
                        sx={{ textTransform: 'none' }}
                        onClick={(e) => {
                            setSelectedNode(node);
                            handleChange(e, "Reports")
                        }}
                        >
                        Add Report Rule
                        </Button>
                        <Button
                        sx={{ textTransform: 'none' }}
                        onClick={(e) => {
                            setSelectedNode(node);
                            handleChange(e, "Notifications")
                        }}
                        >
                        Add Notification Rule
                        </Button>
                        {node.children.length > 0 && (
                        <Button
                            size="small"
                            color="secondary"
                            onClick={() => handleRemoveSubNode(node.id, null)}
                            sx={{textTransform:"none"}}
                        >
                            Remove Subnode
                        </Button>
                        )}
                    </div>
                </li>
            )
        })}
      </ul>
    );
  };
 
 


  const getAllRulesFromTree = (nodes) => {
    let alertrules = [];
    nodes.forEach((node) => {
      alertrules = [...alertrules, ...node.alertrules];
      if (node.children.length > 0) {
        alertrules = [...alertrules, ...getAllRulesFromTree(node.children)];
      }
    });
    return alertrules;
  };


  const getAllReportRulesFromTree = (nodes) => {
    let reportrules = [];
    nodes.forEach((node) => {
      reportrules = [...reportrules, ...node.reportrules];
      if (node.children.length > 0) {
        reportrules = [...reportrules, ...getAllReportRulesFromTree(node.children)];
      }
    });
    return reportrules;
  };


  const getAllNotificationRulesFromTree = (nodes) => {
    let notificationrules = [];
    nodes.forEach((node) => {
      notificationrules = [...notificationrules, ...node.notificationrules];
      if (node.children.length > 0) {
        notificationrules = [...notificationrules, ...getAllNotificationRulesFromTree(node.children)];
      }
    });
    return notificationrules;
  };

  function handleErrorExistsConfirm(){
        setErrExistsOpenDialog(false)
  }

  const postGroupTreecallback = (res) => {
      if(res.status == 200){
          setopenAlarmUpdatedandSaved(true);
      }else{
          setErrMessage('Could not save Groups');
          setErrExists(true);
          setErrExistsOpenDialog(true);
      }
  }

   const deleteGroupTreecallback = (res) => {
      if(res.status == 200){
        setopenAlarmUpdatedandSaved(true);
      }else{
        setErrMessage('Could not save Groups');
        setErrExists(true);
        setErrExistsOpenDialog(true);
      }
  }

  function handleSaveChange(){
    if (Object.keys(groups).length === 0) {
        setErrMessage('No groups available to save');
        setErrExists(true);
        setErrExistsOpenDialog(true);
        return;
    }else{
        postGroupTree(selectedprojectname,userdetails.Userid, groups,postGroupTreecallback) 
        setOpenSaveGrp(false);
    }
  }

  
  return (
    <div className="tree-app-container">
      {/* Dropdown to select group */}
      <CustomDialogBox dialogTitle={"Configuration Not Found"} dialogText={"Alerts Configuration Not Found"} openDialog={errExistsOpenDialog} handleCloseDialog={handleErrorExistsConfirm} handleConfirmDialog={handleErrorExistsConfirm} confirmText={"OK"} cancelText={"Cancel"}/>
      <CustomDialogBox dialogTitle={"Save Groups"} dialogText={"Are you Sure you want to save Groups?"} openDialog={openSaveGrp} handleCloseDialog={handleCloseSaveGrp} handleConfirmDialog={handleSaveChange} confirmText={"Save"} cancelText={"Cancel"}/>
      <CustomDialogBox
          dialogTitle={"Group Creation"}
          dialogText={"Successfully created Group"}
          openDialog={openAlarmUpdatedandSaved}
          handleCloseDialog={handleCloseAlarmUpdatedandSaved}
          handleConfirmDialog={handleConfirmationAlarmUpdatedandSaved}
          confirmText={"Ok"}
          cancelText={"Cancel"}
          type={"Success"}
        />
      <Dialog open={openAddGroupDialog} onClose={handleCloseAddGroupDialog}
            BackdropProps={{
                sx:{
                    backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                }
            }}
            sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
        <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Add New Group</DialogTitle>
        <DialogContent >
            <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF",justifyContent:'center'}}>
                <TextField
                  autoFocus
                  sx={{width: '300px', marginLeft:"13px",marginTop:"0px",fontSize:"16px",fontFamily:"Roboto",marginLeft:"14px",
                      '& .MuiInputBase-input:focus': {
                          color: '#008CD7',
                      },
                      '& .MuiInputBase-root': {
                          fontFamily: 'Roboto',
                          fontSize: '16px',
                          fontWeight: '700',
                          color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                      },
                      '& .MuiInput-root .MuiInputBase-input': {
                          
                      },
                      '& .MuiInputBase-root::before': {
                          borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                      },
                      "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                          borderBottom: '2px solid #008CD7',
                      },
                      '& .MuiInputBase-root::after': {
                          borderBottom: '2px solid #008CD7',

                      },
                  }}
                  fullWidth
                  variant="standard"
                  value={newGroupName}
                  onChange={(e) => setNewGroupName(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      handleConfirmAddGroup();
                    }
                  }}
                />
             </DialogContentText>
        </DialogContent>
        <DialogActions  sx={{justifyContent:'center'}}>
          <CustomButton onClick={handleConfirmAddGroup} buttonText={'OK'} />
          <CustomCancelButton onClick={handleCloseAddGroupDialog} buttonText={'Cancel'}></CustomCancelButton>
        </DialogActions>
      </Dialog>
      <div className="tree-app-save-button-row">
          <div style={{flexGrow:1}}></div>
          <Button disabled={selectedprojectname=="All"} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'100px',fontSize: '16px',textTransform:'capitalize', marginTop:"10px", marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" onClick={handleOpenSaveGrp}>Save</Button>
      </div>
      
      <div className="tree-app-content-row">
            <div className="tree-app-left-section">
                <div className="tree-app-group-selector-container">
                    <FormControl variant="standard" sx={{ marginTop:"0px",marginLeft:"16px"}} fullWidth>
                      <InputLabel style={{color: themechange === 'dark' ? '#FFFFFF' : '#3C3C3C', fontSize: 18, fontWeight: 400}}>Group Name</InputLabel>
                      <Select  labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                IconComponent={KeyboardArrowDownIcon}
                                sx={{
                                    "&:before": {
                                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`  
                                    },
                                    "&:hover:not(.Mui-disabled):before": {
                                        borderBottom: '2px solid #008CD7',
                                    },
                                    "&:after": {
                                        borderBottom: '2px solid #008CD7',
                                    },
                                    margin: 0,
                                    padding: 0,
                                    width: "260px",
                                    fontSize: "18px",
                                    fontFamily: "Roboto",
                                    fontWeight: '700 !important',
                                    color: 'var(--PrimaryText)',
                                    '& .MuiInputBase-input': {
                                        paddingLeft: 0
                                    },
                                    '& .MuiInputBase-input:focus': {
                                        color: 'var(--HighlightedText_Stroke)',
                                        borderBottom: '2px solid var(--HighlightedText_Stroke)',
                                        backgroundColor: 'transparent',
                                        fontWeight: '700 !important',
                                        '& .MuiSvgIcon-root': {
                                            color: 'var(--HighlightedText_Stroke) !important'
                                        },
                                    },
                                    '& .MuiInputBase-input:focus .MuiSvgIcon-root': {
                                        color: 'var(--HighlightedText_Stroke)',       //not working
                                    },
                                    '& .MuiSvgIcon-root': {
                                        color: 'var(--PrimaryText)'
                                    },
                                    '& .MuiNativeSelect-select': {
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                    },
                                    '& .MuiNativeSelect-select option': {
                                        backgroundColor: 'var(--dropdown-bg) !important',
                                        fontSize: "18px",
                                        fontFamily: "Roboto",
                                        fontWeight: 400,
                                        color: 'var(--PrimaryText) !important',
                                        borderBottom: '2px solid var(--HighlightedText_Stroke)',  //not working
                                    },
                                    '& .MuiNativeSelect-select option:checked': {
                                        backgroundColor: 'var(--dropdown-bg) !important',
                                        color: 'var(--White) !important',
                                        fontWeight: '700 !important',
                                        borderColor: '2px solid var(--HighlightedText_Stroke)'
                                    },
                                    '& .MuiInputBase-input option:hover': {
                                        backgroundColor: '#005D8F !important',
                                    },
                    
                                }}
                                MenuProps={{
                                    PaperProps:{
                                        sx:{
                                            width:"160px",
                                            bgcolor:themechange==='dark'?'#3C3C3C':'#C1C1C1',
                                            borderBottom:'2px solid #008CD7',
                                            borderRadius:0,
                                            boxShadow:'none',
                                            maxHeight:'250px',
                                            overflow:'auto',
                                            color:themechange==='dark'?'#FFFFFF':'#3C3C3C',
                                        }
                                    },               
                                }}
                            value={selectedGroup} onChange={handleGroupChange}>
                            {Object.keys(groups).map((group) => (
                                <MenuItem key={group} value={group}>
                                {group}
                                </MenuItem>
                            ))}
                      </Select>
                    </FormControl>
                </div>
                    {/* Button to add a new group */}
                    <Button sx={{textTransform:"none"}} onClick={handleOpenAddGroupDialog} color="primary">
                        Add New Group
                    </Button>
                    {/* Button to remove selected group */}
                    <Button 
                        sx={{textTransform:"none"}} 
                        onClick={() => handleRemoveGroup(selectedGroup)} 
                        color="secondary"
                        disabled={!selectedGroup}
                    >
                        Remove Group
                    </Button>
                <div className="tree-app-tree-display">
                   

                  <div className="tree-app-tree-content">
                      {/* Display the selected group's tree */}
                      {selectedGroup && renderTree(treeData)}
                  </div>

                    {/* Dialog for adding nodes */}
                    <Dialog open={openAddNodeDialog} onClose={() => setOpenAddNodeDialog(false)}
                      BackdropProps={{
                          sx:{
                              backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                          }
                      }}
                      sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
                      <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{selectedNode ? `Add Subnode to ${selectedNode.label}` : 'Add New Node'}</DialogTitle>
                        <DialogContent>
                           <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF",justifyContent:'center'}}>
                              <TextField
                              autoFocus
                              sx={{width: '300px', marginLeft:"13px",marginTop:"0px",fontSize:"16px",fontFamily:"Roboto",marginLeft:"14px",
                                  '& .MuiInputBase-input:focus': {
                                      color: '#008CD7',
                                  },
                                  '& .MuiInputBase-root': {
                                      fontFamily: 'Roboto',
                                      fontSize: '16px',
                                      fontWeight: '700',
                                      color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                                  },
                                  '& .MuiInput-root .MuiInputBase-input': {
                                      
                                  },
                                  '& .MuiInputBase-root::before': {
                                      borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                                  },
                                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                      borderBottom: '2px solid #008CD7',
                                  },
                                  '& .MuiInputBase-root::after': {
                                      borderBottom: '2px solid #008CD7',

                                  },
                              }}
                                  variant="standard"
                                  label="Subnode Name"
                                  value={newNodeName}
                                  onChange={(e) => setNewNodeName(e.target.value)}
                                  fullWidth
                              />
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions  sx={{justifyContent:'center'}}>
                            <CustomButton onClick={handleAddSubNode} buttonText={'Add Subnode'} />
                            <CustomCancelButton onClick={() => setOpenAddNodeDialog(false)} buttonText={'Cancel'}></CustomCancelButton>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
            <div className="tree-app-right-section">
                <Box>
                    {/* Tabs Header */}
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs
                        value={value}
                        onChange={handleTabChange}
                        aria-label="basic tabs example"
                        sx={{
                            width: 'auto',
                            '& .MuiTabs-indicator': { display: 'none' },
                            '& .Mui-selected': {
                                backgroundColor: 'var(--PrimaryBackground)',
                                borderRadius: '0px 0px 0px 0px',
                                color: 'var(--LK_BrandBlue_1) !important',
                                fontWeight: '700 !important',
                                borderTop: "1px solid var(--HighlightedText_Stroke)",
                                borderLeft: "1px solid var(--HighlightedText_Stroke)",
                                borderRight: "1px solid var(--HighlightedText_Stroke)",
                                borderBottom: "1px solid var(--SecondaryBackground)",
                            },
                            '& .MuiTab-root': {
                                padding: '8px 8px 6px 8px !important',
                                margin: '0px !important',
                                minWidth: '63px',
                            },
                            minHeight: '30px',
                            marginBottom: '-3px'
                        }}
                        >
                        <Tab sx={{textTransform: 'none', minHeight: "30px", height: "30px",}}
                                                style={{
                                                    color: "var(--GreyVariation_2)",
                                                    fontFamily: "Roboto",
                                                    fontSize: "14px",
                                                    fontWeight: 400,
                                                    lineHeight: "16.75px",
                                                    textTransform: "capitalize",
                                                }} label="Alerts" value="Alerts" />
                        <Tab sx={{textTransform: 'none', minHeight: "30px", height: "30px",}}
                                                style={{
                                                    color: "var(--GreyVariation_2)",
                                                    fontFamily: "Roboto",
                                                    fontSize: "14px",
                                                    fontWeight: 400,
                                                    lineHeight: "16.75px",
                                                    textTransform: "capitalize",
                                                }} label="Reports" value="Reports" />
                        <Tab sx={{textTransform: 'none', minHeight: "30px", height: "30px",}}
                                                style={{
                                                    color: "var(--GreyVariation_2)",
                                                    fontFamily: "Roboto",
                                                    fontSize: "14px",
                                                    fontWeight: 400,
                                                    lineHeight: "16.75px",
                                                    textTransform: "capitalize",
                                                }} label="Notifications" value="Notifications" />
                        </Tabs>
                    </Box>
                    {/* Tab Content Panels */}
                    {value === 'Alerts' && (
                        <Box className="tree-app-tab-content" sx={{ backgroundColor: 'var(--PrimaryBackground)', width: '97%', border: "1px solid var(--HighlightedText_Stroke)", height:`calc(105vh - ${pagesize}px)`, boxSizing:'border-box', color:(themechange == 'light')?"#19191B":"#FFFFFF", display:'flex', flexDirection:'row', paddingLeft:"20px", paddingTop:"20px" }} style={{ overflow: "auto", }}>
                            {alarmRules.map((rule) => {
                                const allExistingRules = getAllRulesFromTree(treeData);
                                const isRuleAlreadyAdded = allExistingRules.includes(rule.TagID);
                                return (
                                <div className="tree-app-rule-container">
                                    <FormControlLabel
                                        key={rule.TagID}
                                        control={
                                        <Checkbox
                                            checkedIcon={<CheckBoxOutlinedIcon />}
                                            style={{ color: 'var(--SecondaryText)', color: "#008CD7" }}
                                            checked={selectedRules.includes(rule.TagID)}
                                            onChange={() => handleRuleSelection(rule)}
                                            disabled={isRuleAlreadyAdded}
                                            sx={{
                                                color: 'var(--HighlightedText_Stroke)',
                                                '& .MuiSvgIcon-root': { fontSize: '20px' },
                                            }}
                                        />
                                        }
                                        label={rule.Alert_rule_name}
                                    />
                                </div>
                                
                                );
                            })}
                            <br />
                            <Button
                                sx={{ textTransform: 'none', mt: "5px",height:"30px" }}
                                onClick={() => setOpenAddRuleDialog(true)}
                            >
                                Add Alert Rule
                            </Button>
                        </Box>
                    )}
                    {value === 'Reports' && (
                        <Box className="tree-app-tab-content" sx={{ backgroundColor: 'var(--PrimaryBackground)', width: '97%', border: "1px solid var(--HighlightedText_Stroke)", height:`calc(105vh - ${pagesize}px)`, boxSizing:'border-box', color:(themechange == 'light')?"#19191B":"#FFFFFF", display:'flex', flexDirection:'row', paddingLeft:"20px", paddingTop:"20px" }} style={{ overflow: "auto", }}>
                            {reportRules.map((rule) => {
                                const allExistingRules = getAllReportRulesFromTree(treeData);
                                const isRuleAlreadyAdded = allExistingRules.includes(rule);
                                return (
                                  <div className="tree-app-rule-container">
                                <FormControlLabel
                                    key={rule}
                                    control={
                                    <Checkbox
                                        checkedIcon={<CheckBoxOutlinedIcon />}
                                        style={{ color: 'var(--SecondaryText)', color: "#008CD7" }}
                                        checked={selectedReportRules.includes(rule)}
                                        onChange={() => handleRuleSelection(rule)}
                                        disabled={isRuleAlreadyAdded}
                                        sx={{
                                            color: 'var(--HighlightedText_Stroke)',
                                            '& .MuiSvgIcon-root': { fontSize: '20px' },
                                        }}
                                    />
                                    }
                                    label={rule}
                                />
                                </div>
                                );
                            })}
                            <Button
                                sx={{ textTransform: 'none', mt: "5px",height:"30px" }}
                                onClick={() => setOpenAddRuleDialog(true)}
                            >
                                Add Report Rule
                            </Button>
                        </Box>
                    )}
                    {value === 'Notifications' && (
                        <Box className="tree-app-tab-content" sx={{ backgroundColor: 'var(--PrimaryBackground)', width: '97%', border: "1px solid var(--HighlightedText_Stroke)", height:`calc(105vh - ${pagesize}px)`, boxSizing:'border-box', color:(themechange == 'light')?"#19191B":"#FFFFFF", display:'flex', flexDirection:'row', paddingLeft:"20px", paddingTop:"20px" }} style={{ overflow: "auto", }}>
                            {notificationRules.map((rule) => {
                                const allExistingRules = getAllNotificationRulesFromTree(treeData);
                                const isRuleAlreadyAdded = allExistingRules.includes(rule);
                                return (
                                  <div className="tree-app-rule-container">
                                <FormControlLabel
                                    key={rule}
                                    control={
                                    <Checkbox
                                        checkedIcon={<CheckBoxOutlinedIcon />}
                                        style={{ color: 'var(--SecondaryText)', color: "#008CD7" }}
                                        checked={selectedNotificationRules.includes(rule)}
                                        onChange={() => handleRuleSelection(rule)}
                                        disabled={isRuleAlreadyAdded}
                                        sx={{
                                            color: 'var(--HighlightedText_Stroke)',
                                            '& .MuiSvgIcon-root': { fontSize: '20px' },
                                        }}
                                    />
                                    }
                                    label={rule}
                                />
                                </div>
                                );
                            })}
                            <Button
                                sx={{ textTransform: 'none', mt: "5px",height:"30px" }}
                                onClick={() => setOpenAddRuleDialog(true)}
                            >
                                Add Notification Rule
                            </Button>
                        </Box>
                    )}
                </Box>
               
            </div>
      </div>


      {/* Dialog for adding rules
      <Dialog open={openAddRuleDialog} onClose={() => setOpenAddRuleDialog(false)}>
        <DialogTitle>{selectedNode ? `Add Rule to ${selectedNode.label}` : 'Add New Rule'}</DialogTitle>
        <DialogContent>
          <FormGroup>
            {alarmRules.map((rule) => (
              <FormControlLabel
                key={rule}
                control={
                  <Checkbox
                    checked={selectedRules.includes(rule)}
                    onChange={() => handleRuleSelection(rule)}
                  />
                }
                label={rule}
              />
            ))}
          </FormGroup>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddRule} color="primary">
            Add Rule
          </Button>
          <Button onClick={() => setOpenAddRuleDialog(false)} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>*/}


      {/* Dialog for adding rules */}
    <Dialog open={openAddRuleDialog} onClose={() => setOpenAddRuleDialog(false)}
            BackdropProps={{
                sx:{
                    backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                }
            }}
            sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}>
        <DialogTitle sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>{selectedNode ? `Add Rule to ${selectedNode.label}` : 'Add New Rule'}</DialogTitle>
        <DialogContent >
            <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF",justifyContent:'center'}}>
                Are you sure to add selected rules?
            </DialogContentText>
        </DialogContent>
        <DialogActions  sx={{justifyContent:'center'}}>
          <CustomButton onClick={handleAddRule} buttonText={'Add Rule'} />
          <CustomCancelButton onClick={() => setOpenAddRuleDialog(false)} buttonText={'Cancel'}></CustomCancelButton>
        </DialogActions>
    </Dialog>
    </div>
  );
};


export default TreeApp;